import {
  RowDataReducerState,
  RowDataReducerAction,
} from "../../../../../types";
import { isNewRecord } from "../../../helpers";

const AR_SUB_TYPE: Map<string[], string> = new Map([
  [
    ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
    "Open-Item Receivable",
  ],
  [
    ["N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y"],
    "Balance-forward Receivable",
  ],
]);

export const getAccountsReceivableSubType = (
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
  scheduleCode: string,
): void => {
  const { rowData, resetState } = rowDataReducerState;
  if (!isNewRecord(rowData)) {
    const subTypeToUpdate =
      Array.from(AR_SUB_TYPE).find(([keys]) =>
        keys.includes(scheduleCode),
      )?.[1] ?? null;

    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey: "sub_type",
        newFieldValue: subTypeToUpdate,
      },
    });

    // Need this to manage `Clear Changes` button state in New/Edit/Clone entries
    dispatch({
      type: "UPDATE_ROW_DATA_REDUCER_STATE",
      payload: {
        resetState: {
          rowData: {
            ...resetState?.rowData,
            sub_type: subTypeToUpdate,
          },
        },
      },
    });
  }
};
